import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.logistics-vehicle')
  .factory('LogisticsVehicleAPI', LogisticsVehicleAPI);

function LogisticsVehicleAPI(): BringozApi {
  return {
    base: `/logisticsVehicle`,
    infiniteScroll: {
      address: `/logisticsVehicle`,
      cmd: 'GET'
    },
    actions: {
      getMany: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      update: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      getDocuments: {
        address: '{id}/document',
        cmd: 'GET',
        updateable: true
      },
      createDocument: {
        address: '{id}/document',
        cmd: 'PUT',
        updateable: false
      },
      exportLogisticsVehicles: {
        address: 'export',
        cmd: 'POST',
        updateable: true
      },
      updateDocument: {
        address: '{id}/document/{documentId}',
        cmd: 'POST',
        updateable: true
      },
      deleteDocument: {
        address: '{id}/document/{documentId}',
        cmd: 'DELETE',
        updateable: true
      },
      getReminders: {
        address: '{id}/reminder',
        cmd: 'GET',
        updateable: true
      },
      createReminder: {
        address: '{id}/reminder',
        cmd: 'PUT',
        updateable: true
      },
      updateReminder: {
        address: '{id}/reminder/{reminderId}',
        cmd: 'POST',
        updateable: true
      },
      deleteReminder: {
        address: '{id}/reminder/{reminderId}',
        cmd: 'DELETE',
        updateable: true
      },
      bindToAgent: {
        address: 'bind',
        cmd: 'POST',
        updateable: true
      },
      unbindVehicle: {
        address: 'unbind',
        cmd: 'POST',
        updateable: true
      },
      getCurrentBoundedByAgent: {
        address: 'byCurrentAgentId',
        cmd: 'GET',
        updateable: true
      },
      deleteLogisticsVehicles: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getVehicleResources: {
        address: '{id}/resources',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
